export const getStepFractionDigit = (step: number) => {
  const fractionDigit = `${step}`.replace(/[0-9]+(\.)/, '').length;

  return fractionDigit;
};

export const getDegFromValue = (value: number, factorValue?: number) =>
  3.6 * (value - (factorValue ?? 0)) - 180;
